import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Chip } from '@material-ui/core';
import { canRetryCompletionRuleMigration } from '../../utils/migration-report.utils';

const STATUS_CONFIG = {
  pending: { label: 'Rules: pending', color: 'default' },
  in_progress: { label: 'Rules: in progress', color: 'default' },
  migrated: { label: 'Rules: migrated', color: 'primary' },
  failed: { label: 'Rules: failed', color: 'secondary' },
  deferred: { label: 'Rules: deferred', color: 'secondary' },
};

/**
 * Shows Approach A completion-rule migration status chip + Retry (CC-15018).
 * Full report/fidelity is loaded only in the View dialog.
 */
const MigrationStatusCell = ({ status, onRetry, retrying, onOpenDetails }) => {
  if (!status) {
    return (
      <Chip size="small" label="Rules: —" variant="outlined" data-testid="migration-status-none" />
    );
  }

  const config = STATUS_CONFIG[status] || { label: `Rules: ${status}`, color: 'default' };

  return (
    <Box display="flex" flexDirection="column" style={{ gap: 4 }} data-testid="migration-status-cell">
      <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: 'wrap' }}>
        <Chip
          size="small"
          label={config.label}
          color={config.color}
          onClick={onOpenDetails}
          data-testid={`migration-status-${status}`}
        />
        {canRetryCompletionRuleMigration(status) && onRetry ? (
          <Button
            size="small"
            color="primary"
            disabled={retrying}
            onClick={onRetry}
            data-testid="migration-retry-button"
          >
            {retrying ? 'Retrying…' : 'Retry'}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

MigrationStatusCell.propTypes = {
  status: PropTypes.string,
  onRetry: PropTypes.func,
  retrying: PropTypes.bool,
  onOpenDetails: PropTypes.func,
};

MigrationStatusCell.defaultProps = {
  status: undefined,
  onRetry: undefined,
  retrying: false,
  onOpenDetails: undefined,
};

export default MigrationStatusCell;
